import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Table,
  Label,
  UncontrolledTooltip,
  Button,
  Modal,
  Tooltip,
} from "reactstrap";

import { withTranslation } from "react-i18next";

import {
  selectStyle,
  getOptions,
  setClassName,
  renderSpinner,
  renderNotFound,
  renderButtons,
} from "../../Libs/CrudUtils/crudUtils";

import { showToast } from "../../Libs/CustomMethods/showToast";

import Breadcrumbs from "../../components/Common/Breadcrumb";

import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";

import { schemaShow } from "./ExceptionValidation";

import Select from "react-select";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import {
  getDataShow,
  setDataShow,
  dataCreate,
  dataEdit,
  setDataIndex,
  apiReset,
} from "../../store/exceptions/actions";
import { isArray } from "../../Libs/CustomMethods/customMethods";

import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import compareAsc from "date-fns/compareAsc";

import br from "date-fns/locale/pt-BR";
import en from "date-fns/locale/en-US";

import moment from "moment";

let validFields = {};

const NewException = ({ t }) => {
  let { idData } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { register, handleSubmit, setValue, errors, trigger } = useForm({
    resolver: yupResolver(schemaShow),
  });

  const [dataValue, setDataValue] = useState(null);
  const [dataValueBk, setDataValueBk] = useState(null);
  const [enableSubmit, setEnableSubmit] = useState(false);

  // #BEGIN - Editable variables

  registerLocale("br", br);
  registerLocale("en", en);

  const [cleanAllModal, setCleanAllModal] = useState(null);
  const [errorAddLine, setErrorAddLine] = useState(null);

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipObj, setTooltipObj] = useState(null);

  const mainPath = "/exceptions";
  const mainTitle = t("Exceptions");
  const path = "/exception";
  const pathTitle = t("Exception");

  const {
    dataShow,
    dataForm,
    loadingDataShow,
    loadingDataCreate,
    loadingDataEdit,
    success,
    error,
  } = useSelector((state) => state.Exception);

  const responseToYup = (data) => {
    let objParsed = {
      name: data?.name,
      timezone: data?.timezone,
      message: data?.message,
      skills_id: data?.skills_id,
      config: data?.config,
    };
    return objParsed;
  };

  const yupToRequest = (data) => {
    let objParsed = {
      name: data?.name,
      timezone: data?.timezone,
      message: data?.message,
      skills_id: data?.skills_id,
      config: data?.config,
    };
    return objParsed;
  };

  const handleCleanAll = () => {
    updateValue("config", null, dataValueBk);
    setCleanAllModal(false);
  };

  const handleAddLine = () => {
    trigger(["configName", "configStart", "configEnd"]);

    try {
      if (
        !dataValue?.configName ||
        !dataValue?.configStart ||
        !dataValue?.configEnd
      ) {
        throw t("Fill all fields");
      }

      if (
        compareAsc(new Date(), dataValue?.configEnd) >= 0 ||
        compareAsc(new Date(), dataValue?.configStart) >= 0
      ) {
        throw t("Start date and end date must be future dates");
      }

      if (compareAsc(dataValue?.configStart, dataValue?.configEnd) >= 0) {
        throw t("The start date must be less than the end date");
      }

      if (errors.configName || errors.configStart || errors.configEnd) {
        // eslint-disable-next-line no-throw-literal
        throw null;
      }

      setErrorAddLine(null);

      const value = [
        ...(dataValue?.config ?? []),
        {
          name: dataValue?.configName,
          dateRange: [dataValue?.configStart, dataValue?.configEnd],
        },
      ];

      updateValue("config", value, dataValueBk);
      updateValue("configName", null, dataValueBk);
      updateValue("configStart", null, dataValueBk);
      updateValue("configEnd", null, dataValueBk);
    } catch (error) {
      setErrorAddLine(error);
    }
  };

  const renderCleanAllModal = () => (
    <Modal isOpen={cleanAllModal}>
      <div className="modal-body font-size-18 text-center">
        {t("Do you want to delete all occurrences")}
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => setCleanAllModal(false)}
          className="btn btn-danger waves-effect"
          data-dismiss="modal"
        >
          {t("No")}
        </button>
        <button
          type="button"
          className="btn btn-secondary waves-effect waves-light"
          onClick={handleCleanAll}
        >
          {t("Yes")}
        </button>
      </div>
    </Modal>
  );

  const renderActionOccurrences = () => (
    <Row>
      <Col lg="4" xl="3">
        <FormGroup>
          <Label>{t("Name") + " *"}</Label>
          <input
            ref={() => register({ name: "configName" })}
            type="text"
            className={setClassName(errors.configName, "form-control")}
            placeholder={t("Enter name")}
            onChange={(e) => {
              let value = e?.target?.value || null;
              setDataValue((prev) => ({ ...prev, configName: value }));
            }}
            value={dataValue?.configName || ""}
          />
          <div className="invalid-feedback d-block">
            {t(errors.configName?.message)}
          </div>
        </FormGroup>
      </Col>
      <Col lg="4" xl="3">
        <FormGroup>
          <Label>{t("Start") + " *"}</Label>
          <DatePicker
            showTimeSelect
            ref={() => register({ name: "configStart" })}
            timeIntervals={1}
            className={setClassName(errors.configStart, "form-control")}
            calendarClassName="filter-data-date-picker"
            placeholderText={t("Enter start")}
            onChange={(value) => {
              var configEnd = new Date(value);
              configEnd.setHours(23);
              configEnd.setMinutes(59);
              configEnd.setSeconds(59);
              configEnd.setMilliseconds(999);
              setDataValue((prev) => ({
                ...prev,
                configStart: value,
                configEnd,
              }));
            }}
            selected={dataValue?.configStart}
            dateFormat="dd/MM/yyyy HH:mm:ss"
            locale={t("en")}
          />
          <div className="invalid-feedback d-block">
            {t(errors.configStart?.message)}
          </div>
        </FormGroup>
      </Col>
      <Col lg="4" xl="3">
        <FormGroup>
          <Label>{t("End") + " *"}</Label>
          <DatePicker
            showTimeSelect
            ref={() => register({ name: "configEnd" })}
            timeIntervals={1}
            className={setClassName(errors.configEnd, "form-control")}
            calendarClassName="filter-data-date-picker"
            placeholderText={t("Enter end")}
            onChange={(value) => {
              value.setSeconds(59);
              value.setMilliseconds(999);
              setDataValue((prev) => ({ ...prev, configEnd: value }));
            }}
            selected={dataValue?.configEnd || dataValue?.configStart}
            minDate={dataValue?.configStart}
            dateFormat="dd/MM/yyyy HH:mm:ss"
            locale={t("en")}
          />
          <div className="invalid-feedback d-block">
            {t(errors.configEnd?.message)}
          </div>
        </FormGroup>
      </Col>
      <Col lg="12" xl="3" className="d-flex align-self-end w-100 pb-3">
        <Button
          outline
          color="secondary"
          className="w-100"
          onClick={handleAddLine}
        >
          <i className="mdi mdi-plus font-size-13 mr-2"></i>
          {t("Add line")}
        </Button>
      </Col>
      <Col>
        <div className="invalid-feedback d-block mb-1">{errorAddLine}</div>
      </Col>
    </Row>
  );

  const renderOccurrences = () => (
    <div>
      <div className="d-flex justify-content-between">
        <Label className="align-self-center">{t("Occurrences") + " *"}</Label>
        <div className="d-flex">
          <div className="align-self-center ml-4">{`Total: ${
            dataValue?.config?.length ?? 0
          }`}</div>
          <div
            className="align-self-center ml-4 text-info pointer"
            onClick={() => setCleanAllModal(true)}
          >
            {t("Clean all")}
          </div>
        </div>
      </div>
      <div
        ref={() => register({ name: "config" })}
        className="table-responsive"
      >
        <PerfectScrollbar>
          <Table>
            <thead className="thead-light">
              <tr>
                <th>{t("Name")}</th>
                <th>{t("Start")}</th>
                <th>{t("End")}</th>
                <th>{t("Action")}</th>
              </tr>
            </thead>
            <tbody>
              {loadingDataShow
                ? renderSpinner()
                : dataValue?.config?.length > 0
                ? dataValue.config
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((item, key) => (
                      <tr key={key}>
                        <td className="column-text-overflow-25">
                          {item?.name}
                        </td>
                        <td>
                          {moment(new Date(item.dateRange[0])).format(
                            "DD/MM/yyyy HH:mm:ss"
                          )}
                        </td>
                        <td>
                          {moment(new Date(item.dateRange[1])).format(
                            "DD/MM/yyyy HH:mm:ss"
                          )}
                        </td>
                        <td className="text-danger text-center px-1 pointer">
                          <i
                            id="tooltip"
                            className="mdi mdi-window-close"
                            onClick={() => {
                              const value = [
                                ...dataValue.config.slice(0, key),
                                ...dataValue.config.slice(key + 1),
                              ];
                              updateValue("config", value, dataValueBk);
                            }}
                          />
                          <UncontrolledTooltip
                            placement="auto"
                            target="tooltip"
                          >
                            {t("Delete")}
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                    ))
                : renderNotFound(t)}
            </tbody>
          </Table>
          <div className="invalid-feedback d-block">
            {t(errors.config?.message)}
          </div>
        </PerfectScrollbar>
      </div>
    </div>
  );

  const renderKeywords = () => (
    <Col lg="6">
      <Row>
        <Col md="12">
          <Label className="w-100">{t("Keywords")}</Label>
          <div className="font-size-12 mb-3">
            <span>
              {t(
                "The keywords below can be used on message to show dynamic data, click below to copy them"
              )}
            </span>
          </div>
          <div className="keywords-notepad font-size-11">
            <div className="keywords-notepad item">
              <ul className="px-3 mb-0">
                {dataForm?.keywords
                  ?.sort((a, b) => (a.word < b.word ? -1 : 1))
                  ?.map((item, key) => (
                    <li
                      key={key}
                      className="mb-1 keywords-li"
                      onClick={() => {
                        navigator.clipboard.writeText(item?.word);
                        setTooltipObj({
                          target: `keywords-li-${key}`,
                          message: `${item?.word} ${t("Copied to keyboard!")}`,
                        });
                      }}
                    >
                      <div
                        id={`keywords-li-${key}`}
                        className="keywords-li label "
                      >
                        {item?.word}
                      </div>
                      {" - "}
                      <span>{item?.messages[0]?.text}</span>
                      {"  "}
                      <i className="mdi mdi-content-copy" />
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          {tooltipOpen && tooltipObj && (
            <Tooltip
              placement="auto"
              isOpen={tooltipOpen}
              target={tooltipObj?.target}
            >
              <div className="keywords-tooltip">{tooltipObj?.message}</div>
            </Tooltip>
          )}
        </Col>
      </Row>
    </Col>
  );

  const renderInputs = () => (
    <Row className="mb-3">
      <Col lg="6">
        <Row>
          <Col xs="12">
            <FormGroup>
              <Label>{t("Name") + " *"}</Label>
              <input
                ref={() => register({ name: "name" })}
                type="text"
                className={setClassName(errors.name, "form-control")}
                placeholder={t("Enter name")}
                onChange={(e) => {
                  let value = e?.target?.value;
                  updateValue("name", value, dataValueBk);
                }}
                value={dataValue?.name ?? ""}
              />
              <div className="invalid-feedback d-block">
                {t(errors.name?.message)}
              </div>
            </FormGroup>
          </Col>
          <Col xs="12">
            <FormGroup>
              <Label>{t("Message") + " *"}</Label>
              <i
                className="fas fa-info-circle px-2 pointer"
                id="message-tooltip"
              />
              <textarea
                ref={() => register({ name: "message" })}
                type="text"
                className={setClassName(errors.message, "form-control")}
                placeholder={t("Enter message")}
                onChange={(e) => {
                  let value = e?.target?.value;
                  updateValue("message", value, dataValueBk);
                }}
                value={
                  dataValue?.message ??
                  t("I'm sorry but we can't meet this skill on this day")
                }
              />
              <div className="invalid-feedback d-block">
                {t(errors.message?.message)}
              </div>
            </FormGroup>
            <UncontrolledTooltip placement="bottom" target="message-tooltip">
              {t(
                "Enter the message that the consumer will receive when there is an attempt to contact within this exception period"
              )}
            </UncontrolledTooltip>
          </Col>
          <Col xs="12">
            <FormGroup className="select2-container">
              {idData ? (
                <div 
                    style={{opacity: 0.5}}
                >
                  <Label 
                  >{t("It's not possible to edit an timezone")}</Label>
                  <div style={{display: "none"}}>
                    <Select
                      ref={() => register({ name: "timezone" })}
                      isDisabled={true}
                    />
                  </div>
                </div>
              ) : (
                <>
                  <Label>{t("Timezone") + " *"}</Label>
                  <Select
                    ref={() => register({ name: "timezone" })}
                    classNamePrefix="select2-selection"
                    className={setClassName(errors.timezone, " select2-selection")}
                    styles={selectStyle}
                    placeholder={t("Choose") + "..."}
                    options={getOptions(
                      dataForm?.timezones.map((e) => ({
                        id: e,
                        name: e.replace("_", " "),
                      })),
                      loadingDataShow
                    )}
                    onChange={(e) => {
                      let value = e?.value;
                      updateValue("timezone", value, dataValueBk);
                    }}
                    value={
                      getOptions(
                        dataForm?.timezones.map((e) => ({
                          id: e,
                          name: e.replace("_", " "),
                        })),
                        loadingDataShow
                      )?.find((e) => e.value === dataValue?.timezone) ?? null
                    }
                  />

                  <div className="invalid-feedback d-block">
                    {t(errors.timezone?.message)}
                  </div>
                </>
              )}
            </FormGroup>
          </Col>
          <Col xs="12">
            <FormGroup className="select2-container">
              <Label>{t("Skill") + " *"}</Label>
              <Select
                ref={() => register({ name: "skills_id" })}
                classNamePrefix="select2-selection"
                className={setClassName(errors.skills, "select2-selection")}
                placeholder={t("Select") + "..."}
                options={getOptions(dataForm?.skills, loadingDataShow)}
                onChange={(e) => {
                  let value = e ? e.map((item) => item.value) : [];
                  updateValue("skills_id", value, dataValueBk);
                }}
                value={getOptions(dataForm?.skills, loadingDataShow).filter(
                  (element) => dataValue?.skills_id?.includes(element.value)
                )}
                isMulti
              />
              <div className="invalid-feedback d-block">
                {t(errors.skills_id?.message)}
              </div>
            </FormGroup>
          </Col>
          <Col xs="12" className="mt-2">
            {renderActionOccurrences()}
            {renderOccurrences()}
            {renderCleanAllModal()}
          </Col>
        </Row>
      </Col>
      {renderKeywords()}
    </Row>
  );

  useEffect(() => {
    setTooltipOpen(true);
    setTimeout(() => {
      setTooltipOpen(false);
    }, 1500);
  }, [tooltipObj]);

  useEffect(() => {
    if (errorAddLine)
      setTimeout(() => {
        setErrorAddLine(null);
      }, 3000);
  }, [errorAddLine]);

  // #END - Editable variables

  const handleCreateEdit = (data) => {
    let obj = yupToRequest(data);
    if (idData) {
      dispatch(dataEdit(idData, obj));
    } else {
      dispatch(dataCreate(obj));
    }
  };

  const updateEnableSubmit = (target, value, data) => {
    let { [target]: tg, ...rest } = validFields;

    let sortedData = isArray(value) ? value.sort() : value;
    let sortedDataBk = isArray(data?.[target])
      ? data?.[target].sort()
      : data?.[target];

    let isEqual = JSON.stringify(sortedDataBk) === JSON.stringify(sortedData);

    validFields = isEqual ? { ...rest } : { ...validFields, [target]: value };

    let enable = Object.keys(validFields)?.length > 0;
    setEnableSubmit(enable);
  };

  const updateValue = useCallback((target, value, data) => {
    updateEnableSubmit(target, value, data);
    setDataValue((prev) => ({
      ...prev,
      [target]: value,
    }));
  }, []);

  const updateValueBk = useCallback((data) => {
    let obj = responseToYup(data);
    setDataValueBk(obj);
  }, []);

  const onToastHidden = useCallback(() => {
    dispatch(apiReset());
    if (success) {
      dispatch(setDataShow({ show: null, form: dataForm }));
      dispatch(setDataIndex({ index: null, form: dataForm }));
      history.push(mainPath);
    }
  }, [dispatch, history, success, dataForm]);

  useEffect(() => {
    dataValueBk &&
      Object.entries(dataValueBk).forEach((item) =>
        updateValue(item[0], item[1], dataValueBk)
      );
  }, [dataValueBk, updateValue]);

  useEffect(() => {
    if (dataValue) {
      Object.entries(dataValue).forEach((item) => {
        if (item[0] === "message" && item[1] === undefined) {
          setValue(
            "message",
            t("I'm sorry but we can't meet this skill on this day")
          );
        } else {
          setValue(item[0], item[1], {
            shouldValidate: item[1],
          });
        }
      });
    }
  }, [dataValue, setValue]);

  useEffect(() => {
    updateValueBk(dataShow);
  }, [dataShow, updateValueBk]);

  useEffect(() => {
    if (idData) {
      dataShow?.id !== idData && dispatch(getDataShow(idData, true));
    } else {
      dataForm
        ? dispatch(setDataShow({ show: null, form: dataForm }))
        : dispatch(getDataShow(null, true));
    }
  }, [dataForm, dataShow?.id, dispatch, idData]);

  useEffect(() => {
    success && showToast(t(success), "success", onToastHidden);
  }, [success, onToastHidden, t]);

  useEffect(() => {
    if (error) {
      if (isArray(error)) {
        error.forEach((element) => {
          let errorMsg = [];
          if (Object.keys(element?.skills)?.length) {
            Object.entries(element.skills).forEach((e) => {
              errorMsg.push(`${e?.[0]}: ${e?.[1].join(", ")}<br>`);
            });
          }
          showToast(
            `${t(element.value)}<br>
            ${errorMsg?.join("")}`,
            "error",
            onToastHidden
          );
        });
      } else {
        showToast(t(error), "error", onToastHidden);
      }
    }
  }, [error, onToastHidden, t]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath={mainPath}
            path={path}
            title={mainTitle}
            breadcrumbItem={
              idData
                ? t("Edit") + " " + pathTitle
                : t("Create") + " " + pathTitle
            }
          />
          <Row>
            <Col xs="12" className="customContent">
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit(handleCreateEdit)}>
                    {renderInputs()}
                    {renderButtons(
                      enableSubmit,
                      loadingDataCreate || loadingDataEdit,
                      mainPath,
                      null,
                      t
                    )}
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewException);
